<template>
  <BreadCrumb PageTitle="Privacy Policy" />
  <PrivacyPolicy />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import PrivacyPolicy from "../../template-components/Miscellaneous/PrivacyPolicy/PrivacyPolicy.vue";

export default defineComponent({
  name: "PrivacyPolicyPage",
  components: {
    BreadCrumb,
    PrivacyPolicy,
  },
});
</script>